<template lang="pug">
  form(
        :action="url"
        :id="id"
        :ref="vueref"
        method="POST"
        )
    template(v-for="(fields, name) in form_data")
      input(v-for="(val, field) in fields"
            :value="prepared(val)"
            :name="`${name}[${field}]`"
            hidden="hidden"
            :key="field"
            )
    input(name="authenticity_token"
          :value="$csrf_token"
          hidden="hidden"
          )
</template>

<script>
export default {
name: "HiddenForm",
  props: {
    vueref: {
      type:    String,
      default: 'form',
    },
    id:  String,
    url: String,
    field_base: String,
    form_data:  Object,
  },
  methods:{
    prepared(val){
      if (typeof(val) == 'object') return JSON.stringify(val);
      return val;
    }
  }
}
</script>

<style scoped>

</style>